// import { data } from 'msw/lib/types/context';
import React from 'react'
import { TravelerContainer } from '../../../common/traveler/TravelerContainer';
import { TravelerGroup } from '../../../common/traveler/TravelerGroup';
import { TravelerGroupHeader } from '../../../common/traveler/TravelerGroupHeader';
import { TravelerMasterContainer } from '../../../common/traveler/TravelerMasterContainer';
import { TravelerMasterRow } from '../../../common/traveler/TravelerMasterRow';
import { TravelerNotesContainer } from '../../../common/traveler/TravelerNotesContainer';
import { useReportSequenceDefinition } from '../../reportSequenceDefinitionQueries';
import { useParams } from "react-router-dom";
import { ReportTravelerGroup } from './ReportTravelerGroup';


// import { ErrorMessage } from "../../../../common/ErrorMessage";

export const ReportSequenceTraveler = (Id: any) => {
    console.log("the id is ", Id);
    const { tsdId } = useParams<any>();
    const {
        data: testSequence,
        error: testSequenceError,
        isError: isErrorTestSequence,
        isLoading: isLoadingTestSequence,
    } = useReportSequenceDefinition(tsdId);

    return (
        <TravelerContainer>
            <TravelerMasterContainer>
                <TravelerMasterRow header="Name" data={testSequence?.name} />
                <TravelerMasterRow
                    header="Report Sequence Definition Name"
                    data={testSequence?.name}
                />
                <TravelerMasterRow header="Description" data={testSequence?.description} />
            </TravelerMasterContainer>
            <TravelerNotesContainer />
            <TravelerGroupHeader header="Report" size={2} />
            <TravelerGroupHeader header="Execution Group Name" size={2} />
            <TravelerGroupHeader header="Short Name" size={2}/>
            <TravelerGroupHeader header="Disposition" size={2}/>
            <TravelerGroupHeader header="Product Definition Name" size={2}/>
            <TravelerGroupHeader header="Report Sequence Definition Name" size={2}/>

            {/* {data?.grouped_results.map((groupedResult: any) => (
                <TravelerGroup data={groupedResult} permissions={permissions} />
            ))} */}
            {testSequence?.report_execution_orders.map((reportexecutionorder: any) => (
                <ReportTravelerGroup data={reportexecutionorder} />
            ))}
        </TravelerContainer>
    )
}
